'use client';

import { useEffect, useState } from 'react';

const FINE_POINTER_QUERY = '(pointer: fine)';
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export function useCursorEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const pointer = window.matchMedia(FINE_POINTER_QUERY);
    const motion = window.matchMedia(REDUCED_MOTION_QUERY);

    const compute = () => setEnabled(pointer.matches && !motion.matches);
    compute();

    pointer.addEventListener('change', compute);
    motion.addEventListener('change', compute);

    return () => {
      pointer.removeEventListener('change', compute);
      motion.removeEventListener('change', compute);
    };
  }, []);

  return enabled;
}
